<template>
    <div class="into">
        <h5>请选择您要进入的应用</h5>
        <p>您有 {{appList.length}} 个应用</p>
        <el-select v-model="app" placeholder="请选择" value-key="name">
            <el-option v-for="item in appList" :key="item.id" :label="item.name" :value="item">
            </el-option>
        </el-select>
        <el-button type="primary" @click="into" :disabled="disable">立即进入</el-button>
    </div>
</template>

<script>
    export default {
        name: "SelApp",
        data: function(){
            return{
                app: {},
                appList: [],
                disable:true
            }
        },
        mounted() {
            this.sso()
        },
        methods:{
            //立即进入
            into() {
                if(this.app && this.app.url){
                    window.open(this.app.url.replace('eams', 'dev'),this.app.name)
                }
            },
            getAppList(){
                this.disable = true
                this.$api.get(this.$url.loginAppList).then(res => {
                    if (res) {
                        this.appList = res
                        if(this.appList && this.appList.length==1){
                            this.app = this.appList[0]
                            this.into()
                            this.disable = false
                        }else{
                            this.app = this.appList[0]
                            this.disable = false
                        }
                    }else {
                        // TODO:没有应用权限的处理
                        this.$alert(data.message , '系统提示',{
                            confirmButtonText:'确定',
                            callback: action => {
                                this.$api.post(this.$url.logout, {}, (data, isOk) => {
                                    if(isOk){
                                        sessionStorage.clear();
                                        this.$router.push('/ssoLogin')
                                    }
                                })
                            }
                        })
                    }
                })
            },
            sso() {
                this.$api.post(this.$url.sso).then(resp => {
                    if (resp) {
                        this.getAppList()
                    } else {
                        this.$router.push("/ssoLogin");
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .into {
        width: 445px;
        height: 454px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 18px 0px rgba(82, 112, 113, 0.1);
        padding: 0 60px;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: 233px;
        box-sizing: border-box;
        z-index: 9;

        h5 {
            font-size: 20px;
            font-weight: 500;
            color: rgba(74, 74, 74, 1);
            line-height: 28px;
            padding-top: 57px;
        }

        p {
            font-size: 12px;
            font-weight: 400;
            color: rgba(175, 179, 187, 1);
            line-height: 14px;
            padding-top: 4px;
        }

        /deep/ .el-select {
            margin-top: 35px;
            height: 65px;

            /deep/ .el-input {
                height: 65px;
            }

            /deep/ .el-input__inner {
                height: 65px;
            }
        }
    }
</style>
